<template>
<div class="productInfoComponents">
    <h3 class="columnTit"><span>拍品信息</span></h3>
    <div class="productDetailBox">
        <div class="productArea" v-if="extraInfo.length">
            <dl class="fix category ">
                <dt>拍品名称</dt>
                <dd v-html="proTitle"></dd>
            </dl>
            <template v-for="(item,i) in extraInfo">
                <dl class="fix author" :key="i" v-if="item.type=='author'">
                    <dt>{{item.label}}</dt>
                    <dd>
                        <template v-for="(author,index) in item.isSample">
                            <span v-if="author.id == 0" :key="index" class="hasLink">{{author.name}}</span>
                            <a href="javascript:;" :key="index" class="hasLink" v-else-if="$route.query.from">
                                {{author.name}}
                            </a>
                            <a :key="index" target="_blank" @click="jumpUrl(author.name)" class="hasLink" href="javascript:;"  v-else>
                                {{author.name}}
                            </a>
                        </template>
                    </dd>
                </dl>
            </template>
            <template v-for="(item,i) in extraInfo">
                <dl class="fix" v-if="item.type == 'class' && item.text != ''" :key="i">
                    <dt>{{item.label}}</dt>
                    <dd><a :href="'https://artso.artron.net/auction/search_auction.php?keyword=&Status=0&ClassCode='+item.classCode" target="_blank">{{item.text}}</a></dd>
                </dl>
            </template>
            <template v-for="(item,i) in extraInfo">
                <dl class="fix" v-if="item.label == '创作年代'" :key="i">
                    <dt>{{item.label}}</dt>
                    <dd><span v-html="desc(item.text)"></span></dd>
                </dl>
            </template>
            <template v-for="(item,i) in extraInfo">
                <dl class="fix" v-if="item.label == '尺寸'" :key="i">
                    <dt>{{item.label}}</dt>
                    <dd><span v-html="desc(item.text)"></span></dd>
                </dl>
            </template>
            <template v-for="(item,i) in extraInfo">
                <dl class="fix" v-if="item.type == 'gujia'" :key="i">
                    <dt>{{item.label}}</dt>
                    <dd class="item-red">{{item.smallText}} <span v-html="desc(item.text)"></span></dd>
                </dl>
            </template>
            <template v-for="(item,i) in extraInfo">
                <dl class="fix price" :key="i" v-if="item.type=='price'">
                    <dt>{{item.label}}</dt>
                    <template v-if="isLogin&&isMem==1">
                        <template v-if="item.text=='流拍'||item.text=='撤拍'||item.text=='未提供'">
                            <dd class="item-red">{{item.text}} <img  @click="gotoDownLoad" src="@/assets/imgs/Frame1877@2x.png" alt="" style="cursor: pointer;height: 28px;margin-left: 15px;"   /></dd>
                        </template>
                        <template v-else>
                            <dd class="item-red">{{item.smallText}} {{item.text}}<img  @click="gotoDownLoad" src="@/assets/imgs/Frame1877@2x.png" alt="" style="cursor: pointer;height: 28px;margin-left: 15px;"   /></dd>
                        </template>

                    </template>
                    <template v-else>
                        <dd><a style="color:#f5222d;" href="javascript:;" @click="gotoLogin">
                                <template v-if="item.text=='未提供'">
                                    {{item.text}}
                                </template>
                                <template v-else>
                                    {{item.smallText}}&nbsp;{{item.nonMemberText}}
                                </template>

                            </a> <img @click="gotoLogin" src="@/assets/imgs/memberview.png" alt="" style="cursor: pointer;width:150px;height:24px;margin-left: 15;object-fit: contain;" /></dd>
                    </template>
                </dl>
            </template>
        </div>
        <div class="productArea" v-if="attribute.length">
            <template v-for="(item,i) in attribute">
                <dl class="fix" :key="i" v-if="item.label=='拍卖日期'">
                    <dt>{{item.label}}</dt>
                    <dd>{{item.text}}</dd>
                </dl>
            </template>
            <template v-for="(item,i) in attribute">
                <dl class="fix" :key="i" v-if="item.type=='company'">
                    <dt>{{item.label}}</dt>
                    <dd>
                        <router-link :to="{path:'/org_detail/'+item.organCode}">
                            {{item.text}}
                        </router-link>
                    </dd>
                </dl>
            </template>
            <template v-for="(item,i) in attribute">
                <dl class="fix" :key="i" v-if="item.type=='special'">
                    <dt>{{item.label}}</dt>
                    <dd>
                        <router-link :to="{path:'/special_detail/'+item.specialCode}">
                            {{item.text}}
                        </router-link>
                    </dd>
                </dl>
            </template>
            <template v-for="(item,i) in attribute">
                <dl class="fix" :key="i" v-if="item.type=='session'">
                    <dt>{{item.label}}</dt>
                    <dd>
                        <router-link :to="{path:'/meeting_detail/'+item.sessionCode}">
                            {{item.text}}
                        </router-link>
                    </dd>
                </dl>
            </template>
        </div>
        <div class="productArea">
            <template v-for="(item,i) in extraInfo">
                <dl class="fix czText handText" :key="i"  v-if="item.label=='材质'">
                    <dt>{{item.label}}</dt>
                    <dd>
                        <span v-html="desc(item.text)"></span>
                        <!-- <a href="javascript:;" v-if="ifShowCz && showCz" @click="clickCzOpen">展开</a>
                        <a href="javascript:;" v-if="!ifShowCz && showCz" @click="clickCzClose">收起</a> -->
                    </dd>
                </dl>
            </template>
            <template v-for="(item,i) in extraInfo">
                <dl class="fix xzText handText" :key="i"  v-if="item.label=='形制'">
                    <dt>{{item.label}}</dt>
                    <dd>
                        <span v-html="desc(item.text)"></span>
                        <!-- <a href="javascript:;" v-if="ifShowXz && showXz" @click="clickXzOpen">展开</a>
                        <a href="javascript:;" v-if="!ifShowXz && showXz" @click="clickXzClose">收起</a> -->
                    </dd>
                </dl>
            </template>
            <template v-for="(item,i) in extraInfo">
                <dl class="fix tsText handText" :key="i"  v-if="item.label=='题识'">
                    <dt>{{item.label}}</dt>
                    <dd>
                        <span v-html="desc(item.fullText)"></span>
                        <!-- <a href="javascript:;" v-if="ifShowTs && showTs" @click="clickTsOpen">展开</a>
                        <a href="javascript:;" v-if="!ifShowTs && showTs" @click="clickTsClose">收起</a> -->
                    </dd>
                </dl>
            </template>
            <template v-for="(item,i) in extraInfo">
                <dl class="fix bookText handText"  :key="i" v-if="item.label=='著录'">
                    <dt>{{item.label}}</dt>
                    <dd>
                        <span v-html="desc(item.fullText)"></span>
                        <!-- <a href="javascript:;" v-if="ifShowBook && showBook" @click="clickOpen">展开</a>
                        <a href="javascript:;" v-if="!ifShowBook && showBook" @click="clickClose">收起</a> -->
                    </dd>
                </dl>
            </template>
            <template v-for="(item,i) in extraInfo">
                <dl class="fix descText handText" :key="i" v-if="item.label=='拍品描述'">
                    <dt>{{item.label}}</dt>
                    <dd>
                        <span v-html="desc(item.fullText)"></span>
                        <!-- <a href="javascript:;" v-if="ifShowDesc && showFull" @click="clickDescOpen">展开</a>
                        <a href="javascript:;" v-if="!ifShowDesc && showFull" @click="clickDescClose">收起</a> -->
                    </dd>
                </dl>
            </template>
        </div>
        <div class="productArea" v-if="qrcodePic">
            <dl>
                <dt>二维码</dt>
                <dd>
                    <div class="codeBox">
                        <img :src="qrcodePic" alt="" class="qrCode">
                        <div class="codeDiv">
                            <p>雅昌拍卖图录</p>
                            <span>扫描左侧二维码手机查看</span>
                        </div>
                    </div>
                </dd>
            </dl>
        </div>
    </div>
</div>
</template>

<script>
import {
    sendScData
} from "@/utils/buriedPoint";
import {
    getMemType
} from "@/api/auction";
export default {
    props: {
        proTitle: {
            type: String
        },
        extraInfo: {
            type: Array
        },
        pcExtraInfo: {
            type: Array
        },
        attribute: {
            type: Array
        },
        qrcodePic: {
            type: String
        },
        status: {
            type: Number
        },
        isLogin: {
            type: Number
        },
        scJSON: {
            type: Object,
            default () {
                return {
                    auction_items_id: '',
                    auction_items_name: ''
                }
            }
        }
    },
    name: "productInfo",
    data() {
        return {
            showFull: true,
            ifShowDesc: true,
            showBook: true,
            msg: '展开',
            ifShowBook: true,
            isMem: 0,
            showTs: true,
            ifShowTs: true,
            showXz: true,
            ifShowXz: true,
            showCz: true,
            ifShowCz: true,
        }
    },
    computed: {
        pmstatus() {
            return this.status
        },
    },
    mounted() {			
        setTimeout(() => {
            this.handleLine()
            this.getMemTypeFun()
            this.handleText()
            this.handleTs()
            this.handleXz()
            this.handleCz()
        }, 300)
    },
    methods: {
        getMemTypeFun() {
            getMemType().then((res) => {
                if (res.code == 0) {
                    this.isMem = res.data.isMember
										if(!(this.isLogin&&this.isMem==1)){
											var sensors = window["sensorsDataAnalytic201505"];
											if (sensors) {
												sensors.track("vipBenefitsEntryPage", {
													current_page: '拍品详情页成交价',
												});
											}
										}
                }
            })
        },
        handleLine() {
            this.$nextTick(() => {
                if (!document.querySelector('.bookText')) {
                    return false
                }
                const textH = document.querySelector('.bookText').offsetHeight;
                // 高度自适应
                if (textH <= 44) {
                    this.ifShowBook = false
                    this.showBook = false
                }
            });
        },
        handleText() {
            this.$nextTick(() => {
                if (!document.querySelector('.descText')) {
                    return false
                }
                const textH = document.querySelector('.descText').offsetHeight;
                // 高度自适应
                if (textH <= 44) {
                    this.ifShowDesc = false
                    this.showFull = false
                }
            });
        },
        handleTs() {
            this.$nextTick(() => {
                if (!document.querySelector('.tsText')) {
                    return false
                }
                const textH = document.querySelector('.tsText').offsetHeight;
                // 高度自适应
                if (textH <= 44) {
                    this.ifShowTs = false
                    this.showTs = false
                }
            });
        },
        handleXz() {
            this.$nextTick(() => {
                if (!document.querySelector('.xzText')) {
                    return false
                }
                const textH = document.querySelector('.xzText').offsetHeight;
                // 高度自适应
                if (textH <= 44) {
                    this.ifShowXz = false
                    this.showXz = false
                }
            });
        },
        handleCz() {
            this.$nextTick(() => {
                if (!document.querySelector('.czText')) {
                    return false
                }
                const textH = document.querySelector('.czText').offsetHeight;
                // 高度自适应
                if (textH <= 44) {
                    this.ifShowCz = false
                    this.showCz = false
                }
            });
        },

        clickOpen() {
            document.querySelector('.bookText').classList.remove('bookOver')
            this.ifShowBook = false
        },
        clickClose() {
            document.querySelector('.bookText').classList.add('bookOver')
            this.ifShowBook = true
        },

        clickDescOpen() {
            document.querySelector('.descText').classList.remove('bookOver')
            this.ifShowDesc = false
        },
        clickDescClose() {
            document.querySelector('.descText').classList.add('bookOver')
            this.ifShowDesc = true
        },

        clickTsOpen() {
            document.querySelector('.tsText').classList.remove('bookOver')
            this.ifShowTs = false
        },
        clickTsClose() {
            document.querySelector('.tsText').classList.add('bookOver')
            this.ifShowTs = true
        },

        clickXzOpen() {
            document.querySelector('.xzText').classList.remove('bookOver')
            this.ifShowXz = false
        },
        clickXzClose() {
            document.querySelector('.xzText').classList.add('bookOver')
            this.ifShowXz = true
        },

        clickCzOpen() {
            document.querySelector('.czText').classList.remove('bookOver')
            this.ifShowCz = false
        },
        clickCzClose() {
            document.querySelector('.czText').classList.add('bookOver')
            this.ifShowCz = true
        },

        desc(msg) {
            let text = msg
            if (text.indexOf('\r\n') != -1) {
                text = text.replace(/\r\n/g, '<br/>')
            } else if (text.indexOf('\n') != -1) {
                text = text.replace(/\n/g, '<br/>')
            }
            return text
        },
        gotoDownLoad() {
					
            window.location.href = 'https://artexpress.artron.net/download/tulu'
        
        },
        gotoLogin() {
					
            this.auctionButtonClick()
            if (this.$route.query.from) {
                return false
            }
            if (!this.isLogin) {
                window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
            } else if (this.isMem != 1) {
                window.location.href = 'https://member.artron.net/memCenter/collect?business_id=50001&source_page=7&only=5001&sourceReferer='+encodeURIComponent(window.location.href)
            }

        },
        jumpUrl(name){
            if(name.indexOf("（") != -1){
                window.location.href= 'https://artso.artron.net/auction/search_auction.php?keyword='+name.slice(0, name.indexOf("（"));

            }else{
                window.location.href= 'https://artso.artron.net/auction/search_auction.php?keyword='+name;
            }
        
          this.auctionButtonClick();
        },
        auctionButtonClick() {
					//埋点
					sendScData('clickVip',{
							current_page:'拍品详情页成交价',
							button_name:'拍品详情页-查看成交价'
					});
					sendScData('auctionButtonClick', {
							auction_items_id: this.scJSON.auction_items_id,
							auction_items_name: this.scJSON.auction_items_name,
							button_name: '登陆后查看成交价',
                            the_auction_id: this.scJSON.the_auction_id,
                            the_auction_name: this.scJSON.the_auction_name,
                            auction_company: this.scJSON.auction_company,
                            auction_specia_performance_id: this.scJSON.auction_specia_performance_id,
                            auction_specia_performance_name: this.scJSON.auction_specia_performance_name,
                            auction_first: this.scJSON.auction_first,
                            auction_second: this.scJSON.auction_second,
                            auction_lot_number: this.scJSON.auction_lot_number,
                            auction_state: this.scJSON.auction_state,
                            auction_date: this.scJSON.auction_date,
                            is_price: this.scJSON.is_price
					})
        }
    }
}
</script>

<style lang="scss" scoped>
.productInfoComponents{
        background: url('../../../../assets/imgs/detail_bg1.png') no-repeat;
        background-size: 480px 433px;
        min-height: 433px;
}
.productArea {
    border-bottom: 1px solid #F2F2F2;
    padding: 20px 0;

    dl {
        display: flex;
        line-height: 22px;
        margin-bottom: 10px;
    }

    dl:last-child {
        margin-bottom: 0;
    }

    dt {
        width: 94px;
        color: #8C8C8C;
    }

    dd {
        width: 786px;
    }

    .qrCode {
        width: 60px;
        height: 60px;
    }

    .item-red {
        color: #f5222d;
    }

    .fullTxt a {
        color: #18bd6f;
        margin-left: 20px;
    }

    .handText dd {
        position: relative;

        a {
            display: block;
            position: absolute;
            right: 0;
            padding-left: 50px;
            background-image: linear-gradient(to left, #fff, #fff, rgba(255, 255, 255, 0));
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }

    .bookOver dd {
        max-height: 44px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
}

.codeBox {
    display: flex;
    align-items: center;

    .codeDiv {
        margin-left: 20px;

        p {
            font-size: 16px;
            color: #262626;
            line-height: 19px;
        }

        span {
            font-size: 12px;
            color: #595959;
            line-height: 17px;
        }
    }
}
</style>
